import type { RouteRecordRaw } from "vue-router";
import { APP_CHAT_CUSTOMER_ROUTES } from "@/Generated/Routes/paths";

const CustomerRoutes: RouteRecordRaw[] = [
  {
    ...APP_CHAT_CUSTOMER_ROUTES.subscription.root,
    component: () => import("@/Views/chat/customer/views/ManageSubscription/ManageSubscription.vue"),
    meta: {
      i18nTitle: "user.settings.customer.manage_subscription",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.subscription.plans.root,
    component: () => import("@/Views/settings/subscription/plan/Plan.vue"),
    meta: {
      i18nTitle: "private_plans",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.subscription.sessions.root,
    component: () => import("@/Views/settings/subscription/sessions/Sessions.vue"),
    meta: {
      i18nTitle: "sessions_payments_records",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.subscription.sessions.refound.root,
    component: () => import("@/Views/chat/customer/views/Sessions/RefundSessions.vue"),
    meta: {
      i18nTitle: "sessions_payments_records.reimburse",
    },
  },
  {
    ...APP_CHAT_CUSTOMER_ROUTES.subscription.sessions.register.root,
    component: () => import("@/Views/chat/customer/views/Sessions/RegisterSession.vue"),
    meta: {
      i18nTitle: "sessions_payments_records.register_new_session",
    },
  },
];

export default CustomerRoutes;
